import { render, staticRenderFns } from "./orderInfo.vue?vue&type=template&id=51c78c20&scoped=true&"
import script from "./orderInfo.vue?vue&type=script&lang=js&"
export * from "./orderInfo.vue?vue&type=script&lang=js&"
import style0 from "./orderInfo.vue?vue&type=style&index=0&id=51c78c20&prod&lang=scss&"
import style1 from "./orderInfo.vue?vue&type=style&index=1&id=51c78c20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c78c20",
  null
  
)

export default component.exports